import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';

import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import { Bookset } from 'rebook/apps/catalog/models';

import styles from './style.scss';


const BooksetHorizontalCard = (props) => {
  const bookset = new Bookset(props.bookset);
  const { name, preview, authored_by: authoredBy, rubrics } = bookset;
  return (
    <div className={classNames('swiper-slide', styles.item)}>
      <Link to={bookset.getLink()} className={styles.wrapper}>
        <div className={styles.image}>
          <CroppedImage
            src={preview}
            width="240"
            height="232"
            alt={name} />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
            {name}
          </div>
          {authoredBy && (
            <div className={styles.author}>
              <CroppedImage
                className={styles.authorImage}
                src={authoredBy.avatar}
                width="24"
                height="24"
                alt={authoredBy.display_name} />
              <div className={styles.authorName}>{authoredBy.display_name}</div>
            </div>
          )}
          {get(rubrics, 'length', null) && (
            <div className={styles.rubric}>
              {rubrics[0]}
            </div>
          )}
        </div>
      </Link>
    </div>
  );
};

BooksetHorizontalCard.propTypes = {
  bookset: PropTypes.shape({
    name: PropTypes.string.isRequired,
    preview: PropTypes.string.isRequired,
    absolute_url: PropTypes.string.isRequired,
  }).isRequired,
};

export default BooksetHorizontalCard;
